import { useMutation } from "@tanstack/react-query";
import { doPost, doPut } from "../common/fetchServices";

const STIP_BASE_URL = process.env.REACT_APP_STIP_BASE_URL;

const getUploadRequestUrl = () => `${STIP_BASE_URL}/file-upload/request`;

export const useRequestUploadUrl = () => {
  return useMutation((fileData) => {
    const url = getUploadRequestUrl();
    return doPost(url, fileData);
  });
};

export const useUploadFile = () => {
  return useMutation(({ uploadUrl, fileBlob }) => {
    return doPut(uploadUrl, fileBlob, {
      headers: {
        "Content-Type": fileBlob.type,
      },
    });
  });
};
